<div class="mt-0 mb-3">
    <dp-table [table]="table" [customStyles]="{'cssClass':'table table-hover'}" (selectedRow)="onChangeCheck()"
        [selectable]="true" [showLoading]="showLoading">
    </dp-table>
</div>
